import { getMark } from "../data/work";

// A cohesive brand-mark tile used as a case-study thumbnail.
// Renders the real logo image when available, otherwise a typographic
// wordmark set in the brand colour.
export default function BrandMark({ slug, className = "", size = "grid" }) {
  const m = getMark(slug);

  if (m.img) {
    return (
      <img
        src={m.img}
        alt={`${slug} logo`}
        loading="lazy"
        className={`w-full h-full object-cover ${className}`}
      />
    );
  }

  const big = size === "hero";

  // Refined wordmark lockup (used for UNCOLOGNE).
  if (m.lockup) {
    return (
      <div
        className={`w-full h-full flex flex-col items-center justify-center text-center px-8 ${className}`}
        style={{ backgroundColor: m.bg }}
        data-testid={`brandmark-${slug}`}
      >
        {m.over && (
          <span
            style={{ color: m.fg, opacity: 0.55, fontFamily: "Manrope, sans-serif" }}
            className={`uppercase ${big ? "text-sm tracking-[0.5em]" : "text-[10px] tracking-[0.4em]"}`}
          >
            {m.over}
          </span>
        )}
        <span
          className="mt-6 mb-5"
          style={{ width: big ? 56 : 40, height: 1, backgroundColor: m.fg, opacity: 0.4 }}
        />
        <span
          style={{
            color: m.fg,
            fontFamily: '"Playfair Display", serif',
            fontWeight: 500,
            letterSpacing: big ? "0.34em" : "0.26em",
            textIndent: big ? "0.34em" : "0.26em",
            lineHeight: 1,
          }}
          className={big ? "text-5xl md:text-7xl" : "text-2xl sm:text-3xl md:text-4xl"}
        >
          {m.wordmark}
        </span>
        <span
          className="mt-5 mb-6"
          style={{ width: big ? 56 : 40, height: 1, backgroundColor: m.fg, opacity: 0.4 }}
        />
        {m.tagline && (
          <span
            style={{ color: m.fg, opacity: 0.7, fontFamily: "Manrope, sans-serif" }}
            className={`uppercase ${big ? "text-xs tracking-[0.35em]" : "text-[10px] tracking-[0.25em]"}`}
          >
            {m.tagline}
          </span>
        )}
      </div>
    );
  }

  const fontFamily = m.serif
    ? '"Playfair Display", serif'
    : "Manrope, sans-serif";

  return (
    <div
      className={`w-full h-full flex flex-col items-center justify-center px-6 text-center ${className}`}
      style={{ backgroundColor: m.bg }}
      data-testid={`brandmark-${slug}`}
    >
      <span
        style={{
          color: m.fg,
          fontFamily,
          fontWeight: m.weight || 700,
          letterSpacing: m.spaced ? "0.28em" : "-0.01em",
          lineHeight: 1,
          textIndent: m.spaced ? "0.28em" : 0,
        }}
        className={
          big
            ? "text-5xl sm:text-6xl md:text-7xl"
            : "text-3xl sm:text-4xl md:text-5xl"
        }
      >
        {m.wordmark}
      </span>
      {m.sub && (
        <span
          style={{ color: m.fg, opacity: 0.85, fontFamily: "Manrope, sans-serif" }}
          className={`mt-3 tracking-[0.12em] ${big ? "text-lg" : "text-sm"}`}
        >
          {m.sub}
        </span>
      )}
    </div>
  );
}
